export default __webpack_public_path__ + "static/media/Mouth Disease.ebe9617e.png";